<ul class="space-y-1">
  @for (item of menuItems(); track item.id) {
    <li>
      <button
        type="button"
        [routerLink]="!item.children?.length ? item.route : null"
        (click)="item.children?.length ? toggle(item.id) : null"
        class="w-full flex items-center gap-3 px-3 py-2 rounded-md text-white text-left
               hover:bg-primary-700 focus-visible:ring-2 focus-visible:ring-white"
        [ngClass]="{ 'bg-primary-800': isActive(item.route) }"
        pRipple
        >
        @if (item.icon) {
          <i [ngClass]="item.icon" class="pi text-base"></i>
        }
        <span>{{ item.label }}</span>

        @if (item.children?.length) {
          <i
            class="pi pi-angle-right ml-auto transition-transform duration-200 ease-in-out"
            [ngClass]="{
              'rotate-90': isOpen(item.id),
              'rotate-0': !isOpen(item.id)
            }"
          ></i>
        }
      </button>

      @if (item.children?.length) {
        <ul
          [@expandCollapse]="isOpen(item.id) ? 'open' : 'closed'"
          class="pl-6 mt-1 space-y-1"
          >
          @for (child of item.children; track child.id) {
            <li>
              <a
                [routerLink]="child.route"
                class="block px-3 py-2 rounded-md text-white hover:bg-primary-700 focus-visible:ring-2 focus-visible:ring-white focus-visible:outline-none"
                [ngClass]="{ 'bg-primary-800': isActive(child.route) }"
                pRipple
                >
                {{ child.label }}
              </a>
            </li>
          }
        </ul>
      }
    </li>
  }
</ul>
